import moment from 'moment'

import api from '@/services/api'

export default class ReportAPI {
  /**
   * Initialize a `UserAPI` instance.
   *
   * @param {class} cls  The class to use to create user objects.
   **/
  constructor(cls) {
    this.cls = cls
  }

  static forceFileDownload(response) {
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const disposition = response.headers['content-disposition']

    // I shamelessly stole this from stack overflow. I should clean this up
    var filename = 'file.csv'
    if (disposition && disposition.indexOf('attachment') !== -1) {
      var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
      var matches = filenameRegex.exec(disposition)
      if (matches != null && matches[1]) {
        filename = matches[1].replace(/['"]/g, '')
      }
    }
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `${moment().format('M-D-YY, h.mm.ss a')} - ${filename}`)
    document.body.appendChild(link)
    link.click()
  }

  /**
   * Get the API Client.
   */
  get client() {
    return api.getApiClient()
  }

  retrieveExport(exportUrl) {
    const url = exportUrl
    return this.client
      .get(url)
      .then(response => {
        ReportAPI.forceFileDownload(response)
      })
      .catch(() => {
        // eslint-disable-next-line no-console
        // TODO process error
      })
  }
}
